import React from "react"
import "./NoFilesFound.scss"

const NoFilesFound = () => (
  <p className="no-files-found">Unfortunately, there are no files.</p>
)

export default NoFilesFound
